define('templates',[],function(){

this["JST"] = this["JST"] || {};

this["JST"]["app/assets/templates/account/disable.html"] = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div>\n  <button class="btn btn-danger" type="submit">\n    ' +
((__t = ( Messages("access.confirm_disable.title") )) == null ? '' : __t) +
'\n  </button>\n\n  <strong class="text-error">' +
((__t = ( Messages("access.disable.verify") )) == null ? '' : __t) +
'</strong>\n</div>\n';

}
return __p
};

this["JST"]["app/assets/templates/annotations/annotation.html"] = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="comment-body">\n  <header>\n    <p>\n      <time datetime="' +
((__t = ( created.dateTime )) == null ? '' : __t) +
'" title="' +
((__t = ( created.dateTime )) == null ? '' : __t) +
'">' +
((__t = ( created.fromNow )) == null ? '' : __t) +
'</time>\n    </p>\n\n    <ul class="comment-controls">\n      <li>\n        <a href="#" data-action="edit" title="' +
((__t = ( Messages("comment.edit") )) == null ? '' : __t) +
'">\n          <i class="fa fa-pencil"></i>\n        </a>\n      </li>\n\n      <li>\n        <a href="#" data-action="delete" title="' +
((__t = ( Messages("comment.remove") )) == null ? '' : __t) +
'">\n          <i class="fa fa-times"></i>\n        </a>\n      </li>\n    </ul>\n  </header>\n\n  <div class="comment-content">' +
((__t = ( content )) == null ? '' : __t) +
'</div>\n</div>\n';

}
return __p
};

this["JST"]["app/assets/templates/comments/comment.html"] = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="comment-body">\n  <header>\n    <p>\n      <span class="comment-author">' +
((__t = ( author.name )) == null ? '' : __t) +
'</span>\n      <span>' +
((__t = ( Messages("comment.commented") )) == null ? '' : __t) +
' </span>\n      <time datetime="' +
((__t = ( created.dateTime )) == null ? '' : __t) +
'" title="' +
((__t = ( created.dateTime )) == null ? '' : __t) +
'">\n        ' +
((__t = ( created.fromNow )) == null ? '' : __t) +
'\n      </time>\n    </p>\n\n    <ul class="comment-controls">\n      <li>\n        <a href="#" data-action="reply" title="' +
((__t = ( Messages("comment.reply") )) == null ? '' : __t) +
'">\n          <i class="fa fa-reply"></i>\n        </a>\n      </li>\n\n      ';
 if (currentUser.id === author.id || currentUser.role === "ADMINISTRATOR") { ;
__p += '\n      <li>\n        <a href="#" data-action="edit" title="' +
((__t = ( Messages("comment.edit") )) == null ? '' : __t) +
'">\n          <i class="fa fa-pencil"></i>\n        </a>\n      </li>\n      ';
 } ;
__p += '\n\n      ';
 if (currentUser.role === "ADMINISTRATOR") { ;
__p += '\n        <li>\n          <a href="#" data-action="delete" title="' +
((__t = ( Messages("comment.delete") )) == null ? '' : __t) +
'">\n            <i class="fa fa-times"></i>\n          </a>\n        </li>\n      ';
 } ;
__p += '\n    </ul>\n  </header>\n\n  <div class="comment-content">\n    ' +
((__t = ( content )) == null ? '' : __t) +
'\n  </div>\n\n  <footer>\n    ';
 if (typeof libraryTitle !== "undefined") { ;
__p += '\n      <div class="library-details">\n        <span class="library-title">' +
((__t = ( libraryTitle )) == null ? '' : __t) +
'</span>\n        <a href="' +
((__t = ( href )) == null ? '' : __t) +
'">' +
((__t = ( topicTitle )) == null ? '' : __t) +
'</a>\n      </div>\n    ';
 } ;
__p += '\n\n    <div class="status-and-severity">\n    \n      ';
 if (attachment != "") { ;
__p += '\n        <div class="comment-attachment label label-' +
((__t = ( attachment )) == null ? '' : __t) +
'">\n          <a href="' +
((__t = ( this.collection.baseURL )) == null ? '' : __t) +
's/attachment/get/' +
((__t = ( attachment )) == null ? '' : __t) +
'">\n          ' +
((__t = ( attachment.substring(attachment.indexOf("_") + 1) )) == null ? '' : __t) +
'\n          <i class="fa fa-paperclip"></i></a> \n        </div>\n        <br>\n      ';
 } ;
__p += '\n\n      ';
 if(typeof highlight !== "undefined" && highlight !== "{}" && highlight !== "" && typeof highlight == 'string') { ;
__p += '\n        ';
 if (JSON.parse(highlight)) { ;
__p += '\n          <div class="comment-highlight label label-' +
((__t = ( JSON.parse(highlight).uiData.substring(0,50) )) == null ? '' : __t) +
'" id="c-' +
((__t = ( created.dateTime.getTime() )) == null ? '' : __t) +
'">\n            <a onClick=\'document.getElementById(' +
((__t = ( created.dateTime.getTime() )) == null ? '' : __t) +
').scrollIntoView({block: "center"}); $(document.getElementById(' +
((__t = ( created.dateTime.getTime() )) == null ? '' : __t) +
')).effect("highlight", {color: "orange"}, 1000);\'>\n              <i class="fa fa-eye"></i>\n              ';
 if(JSON.parse(highlight).type == "text" && JSON.parse(highlight) !== undefined) {;
__p += '\n                <i title="' +
((__t = ( JSON.parse(highlight).uiData )) == null ? '' : __t) +
'">"' +
((__t = ( JSON.parse(highlight).uiData.substring(0,50) )) == null ? '' : __t) +
'\n                  ';
 if (JSON.parse(highlight).uiData.length > 50) {;
__p += '...';
 } ;
__p += '"\n                </i>\n              ';
 } else { ;
__p += '\n                <i title="' +
((__t = ( JSON.parse(highlight).uiData )) == null ? '' : __t) +
'"/> Image\n              ';
 } ;
__p += '\n              </a>\n          </div>\n          <br>\n        ';
 } ;
__p += '\n      ';
 } ;
__p += '\n    \n      <span class="comment-status label label-' +
((__t = ( status.className )) == null ? '' : __t) +
'">\n        ' +
((__t = ( Messages(status.text) )) == null ? '' : __t) +
'\n      </span>\n\n      <span class="comment-severity label label-' +
((__t = ( severity.className )) == null ? '' : __t) +
'">\n        ' +
((__t = ( Messages(severity.text) )) == null ? '' : __t) +
'\n      </span>\n      \n    </div>\n  </footer>\n</div>\n';

}
return __p
};

this["JST"]["app/assets/templates/comments/reply.html"] = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="comment-body">\n  <header>\n    <p>\n      <span class="comment-author">' +
((__t = ( author.name )) == null ? '' : __t) +
'</span>\n      <span>' +
((__t = ( Messages("comment.commented") )) == null ? '' : __t) +
' </span>\n      <time datetime="' +
((__t = ( created.dateTime )) == null ? '' : __t) +
'" title="' +
((__t = ( created.dateTime )) == null ? '' : __t) +
'">\n        ' +
((__t = ( created.fromNow )) == null ? '' : __t) +
'\n      </time>\n    </p>\n\n    <ul class="comment-controls">\n      <li>\n        <a href="#" data-action="reply" title="' +
((__t = ( Messages("comment.reply") )) == null ? '' : __t) +
'">\n          <i class="fa fa-reply"></i>\n        </a>\n      </li>\n\n      ';
 if (currentUser.id === author.id || currentUser.role === "ADMINISTRATOR") { ;
__p += '\n        <li>\n          <a href="#" data-action="edit" title="' +
((__t = ( Messages("comment.edit") )) == null ? '' : __t) +
'">\n            <i class="fa fa-pencil"></i>\n          </a>\n        </li>\n      ';
 } ;
__p += '\n\n      ';
 if (currentUser.role === "ADMINISTRATOR") { ;
__p += '\n        <li>\n          <a href="#" data-action="delete" title="' +
((__t = ( Messages("comment.delete") )) == null ? '' : __t) +
'">\n            <i class="fa fa-times"></i>\n          </a>\n        </li>\n      ';
 } ;
__p += '\n    </ul>\n  </header>\n\n  <div class="comment-content">\n    ' +
((__t = ( content )) == null ? '' : __t) +
'\n  </div>\n  \n  ';
 if (attachment != "") { ;
__p += '\n    <footer>\n      <div class="comment-attachment label label-' +
((__t = ( attachment )) == null ? '' : __t) +
'">\n        <a href="' +
((__t = ( this.collection.baseURL )) == null ? '' : __t) +
's/attachment/get/' +
((__t = ( attachment )) == null ? '' : __t) +
'">\n        ' +
((__t = ( attachment.substring(attachment.indexOf("_") + 1) )) == null ? '' : __t) +
'\n        <i class="fa fa-paperclip"></i></a> \n      </div>\n      <br>\n    </footer>\n  ';
 } ;
__p += '\n</div>\n';

}
return __p
};

this["JST"]["app/assets/templates/comments/toc.html"] = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<span class="' +
((__t = ( className )) == null ? '' : __t) +
'">' +
((__t = ( comments )) == null ? '' : __t) +
'</span>\n';

}
return __p
};

this["JST"]["app/assets/templates/feedback/thank.html"] = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<p class="response">' +
((__t = ( Messages("feedback.form.thank_you") )) == null ? '' : __t) +
'</p>\n\n<div class="modal-footer">\n  <button class="btn btn-primary pull-right"\n    data-dismiss="modal" aria-hidden="true">' +
((__t = ( Messages("feedback.form.close") )) == null ? '' : __t) +
'</button>\n</div>\n';

}
return __p
};

this["JST"]["app/assets/templates/libraries/folder.html"] = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<td>\n  <i class="fa fa-folder-open-o"></i>\n  <span class="node-title" contenteditable="true"></span>\n</td>\n<td></td>\n<td>\n  <input class="fa-hidden cb-folder-hidden" type="checkbox" data-action="folder-hide">\n</td>\n<td></td>\n<td></td>\n<td>\n  <a href="#" data-action="folder-delete">\n    <i class="fa fa-trash-o"></i>\n  </a>\n</td>\n';

}
return __p
};

this["JST"]["app/assets/templates/libraries/process-item.html"] = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<td>\n  <i class="fa fa-file-text-o"></i> <span class="name">' +
__e( process.libraryName ) +
'</span>\n  <span class="status label label-info">' +
__e( process.message ) +
'</span>\n</td>\n<td></td>\n<td></td>\n<td></td>\n<td>\n  <span class="version badge">' +
__e( process.libraryVersion ) +
'</span>\n</td>\n<td>\n  <i class="fa fa-spinner fa-spin"></i>\n</td>\n';

}
return __p
};

this["JST"]["app/assets/templates/libraries/process-language.html"] = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<span class="badge language">' +
__e( language ) +
'</span>\n';

}
return __p
};

this["JST"]["app/assets/templates/libraries/process-name.html"] = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<span class="name">' +
__e( name ) +
'</span>\n';

}
return __p
};

this["JST"]["app/assets/templates/libraries/process-status.html"] = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<span class="status label ' +
__e( statusClass ) +
'">' +
__e( message ) +
'</span>\n';

}
return __p
};

this["JST"]["app/assets/templates/libraries/process-version.html"] = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<span class="badge version">' +
__e( version ) +
'</span>\n';

}
return __p
};

this["JST"]["app/assets/templates/search/more.html"] = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<li class="more-results">\n  <button type="button" class="btn btn-primary">' +
((__t = ( Messages("link.more_search_results") )) == null ? '' : __t) +
'</button>\n</li>\n';

}
return __p
};

this["JST"]["app/assets/templates/search/results.html"] = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<li class="' +
((__t = ( className )) == null ? '' : __t) +
'">\n  <p class="link">\n    <i class="' +
((__t = ( icon )) == null ? '' : __t) +
'"></i>\n    <a href="' +
((__t = ( hit.uri )) == null ? '' : __t) +
'"\n       data-library="' +
((__t = ( hit.library )) == null ? '' : __t) +
'"\n       data-version="' +
((__t = ( hit.version )) == null ? '' : __t) +
'"\n       data-language="' +
((__t = ( hit.language )) == null ? '' : __t) +
'"\n       data-path="' +
((__t = ( hit.path )) == null ? '' : __t) +
'"\n       data-fragment="' +
((__t = ( hit.fragment )) == null ? '' : __t) +
'">' +
((__t = ( hit.title )) == null ? '' : __t) +
'</a>\n  </p>\n\n  ';
 if (!singleLibraryMode) { ;
__p += '\n    <p class="library">' +
((__t = ( hit.libraryTitle )) == null ? '' : __t) +
'\n    <span class="version-tag">' +
((__t = ( hit.version )) == null ? '' : __t) +
'</span>\n    <span class="language-tag">' +
((__t = ( hit.language.toUpperCase() )) == null ? '' : __t) +
'</span></p>\n  ';
 } ;
__p += '\n\n  <p class="summary">' +
((__t = ( hit.summary )) == null ? '' : __t) +
' &hellip;</p>\n</li>\n';

}
return __p
};

  return this["JST"];

});
